import { ResultValueType } from "../../enums/result-value-type.enum";
import { PanelResult } from "../../store/slices/order/types";
import { RenderRichText } from "../base";
import PdfCulture from "./PdfCulture";

function PdfResult({ panelResult }: { panelResult: PanelResult }) {
  const availablePanelResultItems = panelResult.panelResultDetails.filter(
    (result) => result.strValue
  );

  const cultureResults = availablePanelResultItems.filter(
    (result) => result.valueType === ResultValueType.Culture
  );
  const editOneResults = availablePanelResultItems.filter(
    (result) => result.valueType === ResultValueType.Edit1
  );
  const otherResults = availablePanelResultItems.filter(
    (result) => (result.valueType !== ResultValueType.Culture) && (result.valueType !== ResultValueType.Edit1)
  );
  return (
    <>
      <div className="flex items-center">
        {panelResult?.panel?.name.split(" ")?.map((subName, index) => (
          <p key={index} className="mb-4 uppercase font-bold mx-0.5">
            {subName}
          </p>
        ))}
      </div>
      {cultureResults.length > 0 && (
        cultureResults.map((resultDetails) => (
          <PdfCulture key={resultDetails._id} resultDetails={resultDetails} />
        ))
      ) 
     }
     {
      otherResults.length > 0 && 
      (
        <div key={panelResult?.groupName} className="mb-10">
          <table width="100%">
            <thead className="border-y-[1px] border-black grid grid-cols-5 text-[12px] pt-0 pb-2">
              <th className="font-medium col-span-2 flex gap-3 items-center justify-center">
                <p>TEST</p> <p> NAME</p>
              </th>
              <th className="font-medium">RESULT</th>
              <th className="font-medium flex gap-3 text-center items-center justify-center">
                <p>REFERENCE</p> <p>RANGE</p>{" "}
              </th>
              <th className="font-medium">UNITS</th>
            </thead>
            <tbody>
              {otherResults.map((resultDetails) => (
                <tr
                  key={resultDetails.easyLabInvestigationDetailsId}
                  className="grid grid-cols-5 text-[12px] my-4"
                >
                  {resultDetails?.strValue && (
                    <>
                      <td className="font-semibold col-span-2">
                        <RenderRichText content={resultDetails?.name} />
                        {resultDetails?.comment !== "" && (
                          <>
                            <p>Comment:</p>
                            <p className="font-normal">
                              <RenderRichText
                                content={resultDetails?.comment}
                              />
                            </p>
                            <p>****************************************</p>
                          </>
                        )}
                      </td>
                      <td className="text-center font-bold mx-auto">
                      <RenderRichText
                                content={resultDetails?.strValue}
                              />
                      </td>
                      {resultDetails?.minValue && resultDetails?.maxValue && (
                        <td className="text-center">
                          {resultDetails?.minValue} - {resultDetails?.maxValue}
                        </td>
                      )}
                      {!resultDetails?.minValue && resultDetails?.maxValue && (
                        <td className="text-center">
                          {resultDetails?.maxValue}
                        </td>
                      )}
                      {resultDetails?.minValue && !resultDetails?.maxValue && (
                        <td className="text-center">
                          {resultDetails?.minValue}
                        </td>
                      )}
                      {!resultDetails?.minValue && !resultDetails.maxValue && (
                        <td className="text-center">--------</td>
                      )}
                      <td className="">
                        <div className="flex justify-center items-center">
                          <RenderRichText content={resultDetails?.unit || ""} />
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
     }
      {
      editOneResults.length > 0 &&
      (
        <div key={panelResult?.groupName} className="mb-10">
          <table width="100%">
            <thead className="border-y-[1px] border-black grid grid-cols-5 text-[12px] pt-0 pb-2">
              <th className="font-medium col-span-2 flex gap-3 items-center justify-center">
                <p>TEST</p> <p> NAME</p>
              </th>
              <th className="font-medium">RESULT</th>
            </thead>
            <tbody>
              {editOneResults.map((resultDetails) => (
                <tr
                  key={resultDetails.easyLabInvestigationDetailsId}
                  className="grid grid-cols-5 text-[12px] my-4"
                >
                  {resultDetails?.strValue && (
                    <>
                      <td className="font-semibold col-span-2">
                        <RenderRichText content={resultDetails?.name} />
                        {resultDetails?.comment !== "" && (
                          <>
                            <p>Comment:</p>
                            <p className="font-normal">
                              <RenderRichText
                                content={resultDetails?.comment}
                              />
                            </p>
                            <p>****************************************</p>
                          </>
                        )}
                      </td>
                      <td className="text-center font-bold col-span-3">
                      <RenderRichText
                                content={resultDetails?.strValue}
                              />
                      </td>
                                         </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
     }
    </>
  );
}

export default PdfResult;
